exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".banner-image[_v-0ca02b17]{background-size:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-0ca02b17&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Terms.vue
// module id = 404
// module chunks = 0